// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"f801717d","388":"d9abfc63","426":"a6b33ccb","798":"d9abfc63","970":"edd4958b","981":"edd4958b","982":"75ee8b5b"}[chunkId] + ".chunk.css";
};